export const WBI_CHOICES =  [
  {value: 0.3, name: '0.3'},
  {value: 0.4, name: '0.4'},
  {value: 0.5, name: '0.5'},
  {value: 0.6, name: '0.6'},
  {value: 0.7, name: '0.7'},
  {value: 0.8, name: '0.8'},
  {value: 0.9, name: '0.9'},
  {value: 1.0, name: '1.0'},
];

export const KL_CHOICES = [
  {value: 0, name: '0'},
  {value: 1, name: '1'},
  {value: 2, name: '2'},
  {value: 3, name: '3'},
  {value: 4, name: '4'},
];

export const REHAB_VIDEO_SUGGESTION_TYPE = [
  {value: 1, name: '膝伸展＋内転位'},
  {value: 2, name: '膝伸展＋中間位'},
  {value: 3, name: '膝伸展＋外転位'},
];

export const SymptomsData = [
  { value: "なし", label: "なし" },
  { value: "動悸", label:"動悸" },
  { value: "息苦しい・息切れ", label:"息苦しい・息切れ" },
  { value: "胸が痛む", label:"胸が痛む" },
  { value: "脈が速い・遅い", label:"脈が速い・遅い" },
  { value: "血圧が高い", label:"血圧が高い" },
  { value: "血圧が低い", label:"血圧が低い" },
  { value: "むくみ", label:"むくみ" },
  { value: "背中が痛い", label:"背中が痛い" },
  { value: "頭痛", label:"頭痛" },
  { value: "熱(°C)", label:"熱(°C)" },
  { value: "鼻水・鼻づまり", label:"鼻水・鼻づまり" },
  { value: "吐き気", label:"吐き気" },
  { value: "咳・たん", label:"咳・たん" },
  { value: "めまい・ふらつき", label:"めまい・ふらつき" },
  { value: "健康診断希望", label:"健康診断希望" }
];

export const DiseasesData = [
  { value: "なし" },
  {
    value: "高血圧"
  },
  { value: "糖尿病" },
  {
    value: "脂質異常症"
  },
  {
    value: "心臓病"
  },
  {
    value: "不整脈"
  },
  {
    value: "肝臓病"
  },
  { value: "腎臓病" },
  { value: "喘息" },
  { value: "脳卒中" },
  { value: "癌" }
];

export const Illness_of_family_membersData = [
  { value: "なし" },
  {
    value: "高血圧"
  },
  { value: "糖尿病" },

  {
    value: "心臓病"
  },
  { value: "喘息" },
  { value: "脳卒中" }
];